import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './CycleList.scss';
import Cycle from './Cycle';
import { TaxTypes, TypeCycle } from '../../../types/general-types';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';

export interface CycleListProps
  extends WithTranslation,
    InjectedExperimentsProps {
  currency: string;
  cycles: TypeCycle[];
  selectedCycle: number;
  onSelectedCycle: (index: number) => void;
  taxType?: TaxTypes;
}

class CycleList extends React.Component<CycleListProps> {
  render() {
    const { cycles, currency, selectedCycle, onSelectedCycle, taxType } =
      this.props;
    const types: ('monthly' | 'yearly' | '2years')[] = [
      'monthly',
      'yearly',
      '2years',
    ];
    const selectedCycleNumber =
      !cycles[1].isEnabled && selectedCycle === 1 ? 2 : selectedCycle;

    return (
      <div className={s.strip} data-hook="packagesList-strip">
        <div className={s.root} data-hook="packagesList">
          {cycles.map((_cycle, index) => (
            <Cycle
              key={index}
              priceCurrency={currency}
              priceAmount={taxType ? _cycle.priceWithTax : _cycle.price}
              type={types[index]}
              savePercentage={_cycle.savePercentage}
              saveTotalAmount={_cycle.saveTotalAmount}
              selected={selectedCycleNumber === index}
              onSelectedCycle={() => onSelectedCycle(index)}
              isEnabled={_cycle.isEnabled}
              discountAmount={_cycle.discountedPrice}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withExperiments(CycleList));
